import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { TaskViewTypes } from '../task-list/enums/task-view-types';

@Injectable({
  providedIn: 'root'
})
export class NavigationHistoryService {
  private previousUrl: string | undefined;
  private id: number;

  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.previousUrl = this.router.url;
      }
    });
  }

  getPreviousUrl(): string | undefined {
    return this.previousUrl;
  }

  setId(id: number) {
    if (id === null) {
      localStorage.removeItem('id');
    } else {
      localStorage.setItem('id', id.toString());
    }
  }

  getId() {
    return Number(localStorage.getItem('id'));
  }

  setTaskView(taskType: TaskViewTypes) {
    if (taskType === null) {
      localStorage.removeItem('taskType');
    } else {
      localStorage.setItem('taskType', taskType.toString());
    }
  }
  getTaskView() {
    return localStorage.getItem('taskType');
  }
}
